import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconClipboard2"><Path fillRule="evenodd" clipRule="evenodd" d="M7 2H17V4H21V22H3V4H7V2ZM8.5 6.5H15.5V3.5H8.5V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2;
